// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { getHeaderName, setPlatformSpecificData } from "#platform/userAgent";
import { SDK_VERSION } from "../constants.js";

export { setPlatformSpecificData };

function getUserAgentString(telemetryInfo: Map<string, string>): string {
  const parts: string[] = [];
  for (const [key, value] of telemetryInfo) {
    const token = value ? `${key}/${value}` : key;
    parts.push(token);
  }
  return parts.join(" ");
}

/**
 * @internal
 */
export function getUserAgentHeaderName(): string {
  return getHeaderName();
}

/**
 * @internal
 */
export async function getUserAgentValue(prefix?: string): Promise<string> {
  const runtimeInfo = new Map<string, string>();
  runtimeInfo.set("ts-http-runtime", SDK_VERSION);
  await setPlatformSpecificData(runtimeInfo);
  const defaultAgent = getUserAgentString(runtimeInfo);
  const userAgentValue = prefix ? `${prefix} ${defaultAgent}` : defaultAgent;
  return userAgentValue;
}
